<template>
    <div class="app">
        <div class="content">
            <div class="greenBg"></div>
            <div class="memberInform" @click="goPersonInfo">
                <img @click.stop="goTouxiangPage" class="icon" :src="avatar" alt="">
                <span class="nick">昵称&nbsp;&nbsp;&nbsp;&nbsp;{{nick}}</span>
                <span class="signature">签名&nbsp;&nbsp;&nbsp;&nbsp;{{sign}}</span>
            </div>
            <div class="topOne">
                <ul>
                    <li>
                        <div class="item itemOne" @click="goZhangHuSafetyPage">
                            <img src="../../assets/images/safetyIcon.png" alt="">
                            <span>账户安全</span>
                            <i class="el-icon-arrow-right"></i>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="contentOne">
                <ul>
                    <li>
                        <div class="item" @click="goMessagePage">
                            <img src="../../assets/images/msgIcon.png" alt="">
                            <span>消息提醒</span>
                            <i class="el-icon-arrow-right"></i>
                        </div>
                    </li>
                    <li>
                        <div class="item" @click="goPreOrderPage">
                            <img src="../../assets/images/myorderIcon.png" alt="">
                            <span>我的预约</span>
                            <i class="el-icon-arrow-right"></i>
                        </div>
                    </li>
                    <li>
                        <div class="item" @click="goMyXiaoFeiPage">
                            <img src="../../assets/images/mycostIcon.png" alt="">
                            <span>我的消费</span>
                            <i class="el-icon-arrow-right"></i>
                        </div>
                    </li>
                    <li>
                        <div class="item" @click="goAboutUsPage">
                            <img src="../../assets/images/introduceIcon.png" alt="">
                            <span>软件介绍</span>
                            <i class="el-icon-arrow-right"></i>
                        </div>
                    </li>
                    <li>
                        <div class="item" @click="goFeedBackPage">
                            <img src="../../assets/images/feedbackIcon.png" alt="">
                            <span>意见反馈</span>
                            <i class="el-icon-arrow-right"></i>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="footerOne" @click="quit">
                <button>退出登录</button>
            </div>
        </div>
        <bottom></bottom>
    </div>
</template>
<script>
import bottom from "../footerTo/bottom";
import { DatetimePicker, Popup, Toast, Indicator, Radio, MessageBox } from "mint-ui";
import store from "@/vuex/store";
import { mapState } from "vuex"; 
import { showUserAction } from '@/assets/js/api'
import { removeLoginSessionLocalStorage, setUserInfoLocalStorage } from '@/assets/js/localStorage'
import avatarDefault from '@/assets/images/thstart.png'
import { regularToast } from '@/assets/js/utilities'
import { cleanJPushAll } from '@/assets/js/pushServices'

export default {
    data() {
    return { 
        avatar:'',
        nick:'',
        sign:'',
        userInfo: {},
    };
    },
    computed: {},
    components: {
      "bottom":bottom,
    },
    methods: {
        //获取用户基本信息
        getUserInfo(){
            showUserAction().then(res => {
                if (res.user) {
                    var user = res.user
                    this.userInfo.sex = user.sex ? user.sex : 0
                    this.userInfo.avatar = user.avatar ? user.avatar : ''
                    this.userInfo.nick = user.nick ? user.nick : ''
                    this.userInfo.address = user.address ? user.address : ''
                    this.userInfo.info = user.info ? user.info : ''
                    this.userInfo.birthday = user.birthday ? user.birthday : ''
                    this.userInfo.identity = user.identity ? user.identity : ''

                    setUserInfoLocalStorage(JSON.stringify(this.userInfo))
                    
                    this.avatar = (user.avatar && user.avatar != '1' && user.avatar != '0') ? user.avatar : avatarDefault
                    this.nick = user.nick ? user.nick : '您还未设置昵称'
                    this.sign = user.info ? user.info : '您还未写签名'
                }
            })
        },
        //跳转头像页面
        goTouxiangPage(){
            this.$router.push({name:"touxiang"})
        },
        // 跳到预约页面
        goPreOrderPage () {
            regularToast('我的预约暂未开放')
        },
        // 跳转到个人信息
        goPersonInfo()
        {
            this.$router.push({ name:"personalInformation" });
        },
        // 跳转到关于我们
        goAboutUsPage()
        {
            this.$router.push({ name:"about" });
        },
        // 跳转到账户安全的页面
        goZhangHuSafetyPage()
        {
            this.$router.push({ name:"zhanghuSafety" });
        },
        // 跳转到意见反馈的页面
        goFeedBackPage()
        {
            this.$router.push({ name:"feedback" });
        },
        // 跳转到消息提醒的页面
        goMessagePage()
        {
            this.$router.push({ name:"msg" });
        },
        // 跳转到我的消费的页面
        goMyXiaoFeiPage()
        {
            this.$router.push({ name:"xiaofeiList" });
        },
        // 退出登录
        quit()
        {
          MessageBox.confirm("",{
              title: '提示',
              message: '确定退出?',
              showCancelButton: true
              }).then(action => {
                  if(action == 'confirm')
                  {
                    removeLoginSessionLocalStorage()
                    cleanJPushAll()
                    this.$router.push({ name:"indexOne" })
                  }
              });
        }
    },
    mounted()
    {
       this.getUserInfo();
    }           
};
</script>

<style scoped>
.app {
  width: 100%;
  height: 100%;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
}
.content{
    background-color: #F1F1F1;
    width: 100%;
    height: 100%;
    overflow: hidden;
}
.greenBg{
    width: 100%;
    height: 4.6rem;
    background-color: rgba(41, 158, 173, 1);
}
.memberInform{
    width: 8.55rem;
    height: 3.66rem;
    border-radius: 0.39rem;
    position: relative;
    top: -2.26rem;
    left: 0.66rem;
    box-shadow: 0 0.03rem 0.24rem 0 rgba(0, 0, 0, 0.7);
    background-color: #fff;
    z-index: 1;
    font-size: 0.42rem;
    color: rgba(0, 0, 0, 0.7);
}
.icon{
    display: block;
    width: 1.87rem;
    height: 1.87rem;
    border-radius: 1.58rem;
    position: absolute;
    top: -1rem;
    left: 3.4rem;
}
.nick{
    position: absolute;
    top: 1.26rem;
    left: 0.58rem;
}
.signature{
    position: absolute;
    top: 2.42rem;
    left: 0.58rem;
}
.topOne{
    width: 100%;
    height: 3rem;
    position: relative;
    top: -3.67rem;
    background-color: #fff;
}
.item{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    width: 94%;
    height: 1.29rem;
    margin-left: 0.53rem;
    background-color: #fff;
    border-bottom: 0.03rem solid rgba(0, 0, 0, 0.1);
}
.item :nth-child(1){
    width: 0.71rem;
    height: 0.71rem;
}
.item :nth-child(2){
    font-size: 0.42rem;
    line-height: 0.61rem;
    color: rgba(0, 0, 0, 0.7);
    flex-grow: 1;
    margin-left: .33rem;
}
.itemOne{
    border: none;
    position: relative;
    top: 1.7rem;
}
.el-icon-arrow-right {
  font-size: 0.63rem;
  color: rgba(16, 16, 16, 1);
  float: right;
  margin-top: 0.13rem;
  margin-right: 0.23rem;
  flex-basis: 10%;
}
.contentOne{
    margin-top: 0.2rem;
    width: 100%;
    height: auto;
    position: relative;
    top: -3.7rem;
    background-color: #fff;
}
.contentOne ul li{
    height: 1.32rem;
    line-height: 1.32rem;
}
.footerOne{
    width: 100%;
    height: 1.32rem;
    background-color: #fff;
    margin-top: 0.2rem;
    margin-bottom: 0.82rem;
    text-align: center;
    position: relative;
    top: -3.71rem;
}
.footerOne button{
    border: none;
    background-color: #fff;
    color: rgba(0, 0, 0, 0.7);
    font-size: 0.42rem;
    padding-top: 0.3rem;
}
</style>



// WEBPACK FOOTER //
// src/components/homepage/mine.vue